module.exports = __webpack_public_path__ + "img/3c.8b13d335.png";